import type { RouteRecordRaw } from 'vue-router'
import { CUSTOMER_BUY_ANALYSIS_FEATURE_ENABLED } from '@/constants/psiRelease'

const statisticsRoutes: RouteRecordRaw[] = [
  {
    path: 'statistics',
    component: () => import('@/pages/statistics/layout.vue'),
    meta: { title: '数据' },
    children: [
      {
        path: '',
        name: 'Statistics',
        component: () => import('@/views/Statistics.vue'),
        meta: { title: '数据概览' },
      },
      {
        path: 'warehouse-product-stats',
        name: 'StatisticsWarehouseProductStats',
        component: () => import('@/pages/warehouse-product-stats/index.vue'),
        meta: { title: '仓库库存商品统计', requiresPsi: true },
      },
      {
        path: 'customer-first-repeat',
        name: 'CustomerFirstRepeat',
        component: () => import('@/pages/statistics/customer-first-repeat.vue'),
        meta: { title: '客服首复购业绩统计表', requiresPsi: true },
      },
      {
        path: 'wechat-first-repeat',
        name: 'WechatFirstRepeat',
        component: () => import('@/pages/statistics/wechat-first-repeat.vue'),
        meta: { title: '微信首复购业绩统计表', requiresPsi: true },
      },
      {
        path: 'customer-first-repeat-distribution',
        name: 'CustomerFirstRepeatDistribution',
        component: () => import('@/pages/statistics/customer-first-repeat-distribution.vue'),
        meta: { title: '客服首复购分布统计表', requiresPsi: true },
      },
      ...(CUSTOMER_BUY_ANALYSIS_FEATURE_ENABLED
        ? [
            {
              path: 'customer-buy-analysis',
              name: 'CustomerBuyAnalysis',
              component: () => import('@/pages/statistics/customer-buy-analysis.vue'),
              meta: { title: '客户消费能力分析', requiresPsi: true },
            },
          ]
        : []),
      {
        path: 'wechat-sales-analysis',
        name: 'WechatSalesAnalysis',
        component: () => import('@/pages/statistics/wechat-sales-analysis.vue'),
        meta: { title: '微信销售综合分析', requiresPsi: true },
      },
      {
        path: 'sales-gross-profit',
        name: 'SalesGrossProfit',
        component: () => import('@/pages/statistics/sales-gross-profit.vue'),
        meta: { title: '销售毛利统计表', requiresPsi: true },
      },
      {
        path: 'region-sales',
        name: 'RegionSalesStatistics',
        component: () => import('@/pages/statistics/region-sales.vue'),
        meta: { title: '地区销售统计', requiresPsi: true },
      },
      {
        path: 'fan-hourly',
        name: 'FanHourlyStatistics',
        component: () => import('@/pages/statistics/fan-hourly.vue'),
        meta: { title: '进粉时段统计', requiresPsi: true },
      },
      {
        path: 'fan-daily',
        name: 'FanDailyStatistics',
        component: () => import('@/pages/statistics/fan-daily.vue'),
        meta: { title: '客服进粉统计', requiresPsi: true },
      },
      {
        path: 'wechat-fan-daily',
        name: 'WechatFanDailyStatistics',
        component: () => import('@/pages/statistics/wechat-fan-daily.vue'),
        meta: { title: '微信进粉统计', requiresPsi: true },
      },
      {
        path: 'sales-department-ranking',
        name: 'SalesDepartmentRanking',
        component: () => import('@/pages/statistics/sales-department-ranking.vue'),
        meta: { title: '销售部门排名分析', requiresPsi: true },
      },
      {
        path: 'sales-performance-share',
        name: 'StatisticsSalesPerformanceShare',
        component: () => import('@/pages/statistics/sales-performance-share.vue'),
        meta: { title: '销售业绩分成统计表', requiresPsi: true },
      },
      {
        path: 'service-monthly-ranking',
        name: 'ServiceMonthlyRanking',
        component: () => import('@/pages/statistics/service-monthly-ranking.vue'),
        meta: { title: '客服月度排名分析', requiresPsi: true },
      },
      {
        path: 'service-first-repeat-net-value',
        name: 'ServiceFirstRepeatNetValue',
        component: () => import('@/pages/statistics/service-first-repeat-net-value.vue'),
        meta: { title: '客服首复购转化总净值', requiresPsi: true },
      },
    ],
  },
]

export default statisticsRoutes
